// Vendor imports
const React = require('react')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const Portal = require('client-v2/common/components/portal')
const withCommonRoot = require('client-v2/common/components/root')
const AppFooter = require('client-v2/common/containers/app-footer/component-smart')
const ArticleProfileModal = require('client-v2/common/containers/article-profile/components/modal-smart')
const AuthModal = require('client-v2/common/containers/auth-modal/component-smart')
// Entry imports
const FeaturedCollectionsSection = require('../containers/featured-collections/component-smart')
const LandingHeader = require('../containers/header/component-smart')
const TopCallToActionSection = require('../containers/top-call-to-action/component')
const DiscoverSection = require('../containers/discover/component-smart')
const BottomCallToActionSection = require('../containers/bottom-call-to-action/component-smart')
const StumbleUponSubmitModal = require('../containers/su-submit-modal/component-smart')

const bem = BemEntity('LoggedOutLandingLayout')

const SCROLL_MARGIN = 90

// Composes page components based on the current URL into a standard layout

class LoggedOutLandingLayout extends React.PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      foldHeight: 0,
      isScrolledToTop: true,
      isScrolledBelowFold: false
    }
    this.setFoldHeight = foldHeight => {
      this.setState({ foldHeight }, this.recalculateScrollState)
    }
    this.recalculateScrollState = this.recalculateScrollState.bind(this)
  }

  componentDidMount() {
    if (typeof window === 'object') {
      this.recalculateScrollState()
      window.addEventListener('scroll', this.recalculateScrollState)
    }
  }

  componentWillUnmount() {
    if (typeof window === 'object') {
      window.removeEventListener('scroll', this.recalculateScrollState)
    }
  }

  recalculateScrollState() {
    const scrollY = window.pageYOffset
    const foldY = this.state.foldHeight
    const isScrolledToTop = scrollY === 0
    const isScrolledBelowFold = scrollY > foldY - SCROLL_MARGIN
    this.setState({ isScrolledToTop, isScrolledBelowFold })
  }

  render() {
    return (
      tag('div', {
        className: bem.block()
      },
        tag('div', {
          className: bem.element('page')
        },
          tag(LandingHeader, {
            isScrolledBelowFold: this.state.isScrolledBelowFold,
            isScrolledToTop: this.state.isScrolledToTop
          }),
          tag('div', {
            className: bem.element('body')
          },
            tag(TopCallToActionSection, {
              onFoldHeightChange: this.setFoldHeight
            }),
            tag('a', { name: 'discover' }),
            tag(DiscoverSection, {
              isHeaderVisible: true,
              isMoreAvailable: false,
              pageCount: 2,
              pageStart: 1
            }),
            tag(FeaturedCollectionsSection),
            tag(DiscoverSection, {
              isHeaderVisible: false,
              isMoreAvailable: true,
              pageStart: 3
            }),
            tag(BottomCallToActionSection)
          ),
          tag(AppFooter)
        ),
        Portal.toModalRoot(
          tag(StumbleUponSubmitModal),
          tag(ArticleProfileModal),
          tag(AuthModal)
        )
      )
    )
  }
}

module.exports = withCommonRoot(LoggedOutLandingLayout)
